import { IconPlus, IconTrashOutline } from '@iwoca/icons';
import clsx from 'clsx';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { PostcodeInput } from '../PostcodeInput/PostcodeInput';
import signupFormStyles from '../SignupForm/SignupForm.module.css';
import { AddressTabs } from './AddressTabs/AddressTabs';
import {
  TMultiAddressInput,
  useMultiAddressInput,
} from './MultiAddressInput.helpers';
import styles from './MultiAddressInput.module.css';

export const MultiAddressInput = ({
  personRole,
  personIndex,
}: TMultiAddressInput) => {
  const {
    additionalAddresses,
    appendAddress,
    removeAddress,
    addresses,
    errors,
    targetAddressIndex,
    setTargetAddressIndex,
  } = useMultiAddressInput({ personRole, personIndex });
  const { checkIntroducerPermission } = useIntroducerData();
  const isDisabled = !checkIntroducerPermission('can_create_applications');

  return (
    <div>
      <AddressTabs
        addresses={addresses}
        targetAddressIndex={targetAddressIndex}
        setTargetAddressIndex={setTargetAddressIndex}
        errors={errors}
        personIndex={personIndex}
        personRole={personRole}
      />
      <div
        className={clsx(signupFormStyles.formField, styles.addressField, {
          [styles.focused]: targetAddressIndex === 0,
        })}
      >
        <PostcodeInput
          personRole={personRole}
          personIndex={personIndex}
          addressIndex={0}
          disabled={isDisabled}
        />
      </div>
      {additionalAddresses.map((_, index) => {
        const addressIndex = index + 1;

        return (
          <div
            data-testid={`secondary-address-${addressIndex}`}
            key={index}
            className={clsx(signupFormStyles.formField, styles.addressField, {
              [styles.focused]: targetAddressIndex === addressIndex,
            })}
          >
            <PostcodeInput
              postcodeLabel={`Residential postcode (Address ${
                addressIndex + 1
              })`}
              addressOption="secondaryAddress"
              personRole={personRole}
              personIndex={personIndex}
              addressIndex={addressIndex}
              disabled={isDisabled}
            />
            <ButtonLink
              type="button"
              className={styles.secondaryAddressCancel}
              data-testid={`delete-secondary-address-${addressIndex}`}
              onClick={() => removeAddress(addressIndex)}
            >
              <IconTrashOutline fontSize="1.4rem" />
            </ButtonLink>
          </div>
        );
      })}
      {addresses.length < 5 && (
        <ButtonLink
          type="button"
          icon={IconPlus}
          iconPosition="left"
          onClick={() => {
            appendAddress({ residential_status: undefined });
          }}
          className={clsx(styles.addAddressButton, {
            [styles.isDisabled]: isDisabled,
          })}
          disabled={isDisabled}
        >
          Add another address
        </ButtonLink>
      )}
    </div>
  );
};
